import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ErrorBoundary.module.scss'
import ErrorImage from '../../assets/images/main-error-illustration.svg'
import { Button } from 'reakit/Button'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo)
        //logErrorToMyService(error, errorInfo);
    }

    render() {
        const { t } = this.props

        if (this.state.hasError) {
            return (
                <div className='page-container'>
                    <div className={styles.titleWrapper}>
                        <p className={`${styles.pageTitle}`}>
                            {t('error_happen')}
                        </p>
                    </div>
                    <div className={styles.errorBoundary}>
                        <div className={styles.subtitle}>
                            {t('error_happen_text')}
                        </div>
                        <a href='/' className={`${styles.linkWrapper}`}>
                            <Button
                                as='button'
                                className={`btn color-primary size-medium rounded shadow ${styles.btnHome}`}
                            >
                                {t('go_to_home')}
                            </Button>
                        </a>
                        <img src={ErrorImage} alt='' />
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}

export default withTranslation()(ErrorBoundary)
